// import './PayBillMethodModal.less';
// export { default as SelectPayMethodItem } from './'

export const prefix = 'bm-c-pay-bill-method-modal';

export { default } from './PayBillMethodModal';
